import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsEmployeeWorkdays from 'graphql/fields/FieldsEmployeeWorkdays'

const fields = {
	'scanned_in_at': 'String',
	'booking_date': '[String]',
}

export default gql(`
	query employees_ero_favourites( ${ HelperGraphql.createFields( fields ) } ) {
		employees_ero_favourites {
			guid
			name
			visible_for_employees
			vacation_mode_active
			
			bookings( booking_date: $booking_date ) {
				guid
				kind
				booking_date
				status
				
				building {
					guid
				}
				
				floor {
					guid
				}
				
				room {
					guid
				}
				
				timeslot {
					timeslot_start
					timeslot_end
					kind
				}
			}
			
			scans( scanned_in_at: $scanned_in_at, status: ["scanned_in","scanned_out"] ) {
				code
				scanned_in_at
				scanned_in_through
				scanned_out_at
				scanned_out_through
			}
			
			workdays {
				${FieldsEmployeeWorkdays}
			}
		}
	}
`);

